export const pageKey = () => {
   const path = window.location.pathname.substring(1).split('/')
   if (path.length >= 3) {
      path.pop()
   }
   return path
}
